import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import HeroWithVideoBackground from './components/Hero';

// Sections extracted from Why.jsx
import AboutUs from './components/sections/AboutUs';
import Vision from './components/sections/Vision';
import HowWeWork from './components/sections/HowWeWork';
import Services from './components/sections/Services';
import ProblemsWeSolve from './components/sections/ProblemsWeSolve';
import WhyIvani from './components/sections/WhyIvani';
import ConnectWithUs from './components/sections/ConnectWithUs';
// import Loader from './components/Loader';
import MagicLoader from './components/MagicLoader';
import { AnimatePresence, motion } from 'framer-motion';

// Using a high-quality image from the assets as a poster for the video background
const heroPoster = require('./assets/ivani/2.jpg');

function App() {
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 6500); // 3.5 seconds as requested

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <AnimatePresence mode="wait">
        {isLoading && <MagicLoader key="loader" />}
      </AnimatePresence>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: isLoading ? 0 : 1 }}
        transition={{ duration: 1, ease: "easeInOut" }}
      >
        <Navbar />
        <HeroWithVideoBackground
          className="relative z-10"
          poster={heroPoster}
          videoSrc="/test.mp4"
        />
        <div className="bg-black relative overflow-x-hidden">
          <AboutUs />
          <Vision />
          <HowWeWork />
          <Services />
          <ProblemsWeSolve />
          <WhyIvani />
          <ConnectWithUs />
        </div>
      </motion.div>
    </>
  );
}

export default App;
